import React, { useState, useRef } from 'react'
import { ColorPicker } from './ColorPicker'

export const ColorField = ({ label, value, onChange }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [triggerRect, setTriggerRect] = useState(null)
  const buttonRef = useRef(null)

  const handleToggle = () => {
    if (!isOpen && buttonRef.current) {
      setTriggerRect(buttonRef.current.getBoundingClientRect())
    }
    setIsOpen(!isOpen)
  }

  return (
    <div style={{ marginBottom: '16px' }}>
      <label style={{ display: 'block', fontSize: '12px', color: '#6b7280', marginBottom: '6px' }}>{label}</label>
      <button
        ref={buttonRef}
        onClick={handleToggle}
        style={{
          width: '100%',
          padding: '10px 12px',
          border: '1px solid #e5e5e5',
          borderRadius: '8px',
          backgroundColor: 'white',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '10px'
        }}
      >
        <div style={{
          width: '24px',
          height: '24px',
          borderRadius: '4px',
          backgroundColor: value || '#ffffff',
          border: '1px solid #e5e5e5'
        }} />
        <span style={{ fontSize: '13px', color: '#374151', fontFamily: 'monospace', textTransform: 'uppercase' }}>
          {value || 'None'}
        </span>
      </button>
      {isOpen && (
        <ColorPicker
          value={value}
          onChange={(color) => onChange(color)}
          onClose={() => setIsOpen(false)}
          label={label}
          triggerRect={triggerRect}
        />
      )}
    </div>
  )
}
